import {
  deleteWithAuth,
  getWithAuth,
  postWithAuth,
  putWithAuth,
} from 'services/http.service';
import {
  GET_DELIVERY_OPTIONS,
  UPDATE_DELIVERY_CONFIG,
  CREATE_SELF_DELIVERY_RANGE,
  UPDATE_SELF_DELIVERY_RANGE,
  DELETE_SELF_DELIVERY_RANGE,
  GET_ALL_DELIVERY_CONFIGS,
  GET_DELIVERY_WEEKLY_SCHEDULE,
  UPDATE_DELIVERY_WEEKLY_SCHEDULE,
} from './url.service';

// Get delivery options (delivery types and third party providers)
export const getDeliveryOptions = () => getWithAuth(GET_DELIVERY_OPTIONS);

// Get all delivery configs for a business (settings page — returns all types at once)
export const getAllDeliveryConfigs = () => getWithAuth(GET_ALL_DELIVERY_CONFIGS);

// Update delivery configuration
export const updateDeliveryConfig = (configData) =>
  putWithAuth(UPDATE_DELIVERY_CONFIG, configData);

// Create self delivery range
export const createSelfDeliveryRange = (rangeData) =>
  postWithAuth(CREATE_SELF_DELIVERY_RANGE, rangeData);

// Update self delivery range
export const updateSelfDeliveryRange = (rangeId, rangeData) =>
  putWithAuth(UPDATE_SELF_DELIVERY_RANGE(rangeId), rangeData);

// Delete self delivery range
export const deleteSelfDeliveryRange = (rangeId) =>
  deleteWithAuth(DELETE_SELF_DELIVERY_RANGE(rangeId));

// Get weekly delivery schedule
export const getDeliveryWeeklySchedule = () => getWithAuth(GET_DELIVERY_WEEKLY_SCHEDULE);

// Update weekly delivery schedule (full 7-day replace)
export const updateDeliveryWeeklySchedule = (scheduleData) =>
  putWithAuth(UPDATE_DELIVERY_WEEKLY_SCHEDULE, scheduleData);
